module.exports = __webpack_public_path__ + "img/border_left_arrow.52dba410.svg";